<template>
    <div>
        <!-- 能耗统计卡片 -->
        <el-row style="margin: 2vh 20px 0; padding: 0 20px;">
            <el-col :span="24">
                <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="功能间名称">
                        <el-input v-model="searchForm.roomName" placeholder="请输入功能间名称"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <!-- 绑定查询方法 -->
                        <el-button type="primary" icon="el-icon-search" @click="handleSearch()">查询</el-button>
                        <el-button @click="resetSearch()" icon="el-icon-refresh">重置</el-button>
                        <el-button type="primary" icon="el-icon-plus" @click="showAddDialog()">新增功能间</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row style="margin-top: 2vh; padding: 20px;overflow: auto;" :gutter="20">
            <!-- 卡片列表区域（移除未使用的index变量） -->
            <div class="card-container">
                <el-col v-for="room in paginatedRoomList" :key="room.id" :span="6" style="margin-bottom: 20px;">
                    <el-card class="room-card" :shadow="selectedRoomId === room.id ? 'hover' : 'always'">
                        <div class="card-header">
                            <span class="room-name">{{ room.roomName }}</span>
                        </div>
                        <div class="card-body">
                            <div class="info-item">
                                <span class="label">房间面积：</span>
                                <span>{{ room.area }} ㎡</span>
                            </div>
                            <div class="info-item">
                                <span class="label">用电量：</span>
                                <span>{{ room.electricity }} kWh</span>
                            </div>
                            <div class="info-item">
                                <span class="label">用水量：</span>
                                <span>{{ room.water }} m³</span>
                            </div>
                            <div class="info-item">
                                <span class="label">房间温度：</span>
                                <span>{{ room.temperature }} ℃</span>
                            </div>
                            <div class="info-item">
                                <span class="label">房间湿度：</span>
                                <span>{{ room.humidity }} %</span>
                            </div>
                            <div class="info-item">
                                <span class="label">挡鼠板：</span>
                                <el-tag :type="room.ratGuard == '1' ? 'success' : 'warning'">
                                    {{ room.ratGuard == 1 ? '开启' : '关闭' }}
                                </el-tag>
                            </div>
                            <div class="info-item">
                                <span class="label">渗水检测：</span>
                                <el-tag :type="room.waterSeepage == '0' ? 'success' : 'danger'">
                                    {{ room.waterSeepage == 0 ? '正常' : '报警' }}
                                </el-tag>
                            </div>
                            <div class="info-item">
                                <span class="label">二氧化碳：</span>
                                <span>{{ room.co2 }} pm</span>
                            </div>
                            <div class="info-item">
                                <span class="label">pm2.5：</span>
                                <span>{{ room.pm25 }} μg/m³</span>
                            </div>
                            <div class="info-item">
                                <span class="label">pm10：</span>
                                <span>{{ room.pm10 }} μg/m³</span>
                            </div>
                            <div class="info-item">
                                <span class="label">功率：</span>
                                <span>{{ room.power }} kw/h</span>
                            </div>
                            <div class="info-item">
                                <span class="label">燃气泄露值：</span>
                                <span>{{ room.gas }} m³</span>
                            </div>
                            <div class="info-item">
                                <span class="label">最后更新时间：</span>
                                <span>{{ room.updateTime }}</span>
                            </div>
                        </div>
                        <div class="card-footer">
                            <el-button type="danger" icon="el-icon-delete" @click="handleDelete(room.id)">删除</el-button>
                            <el-button type="success" icon="el-icon-camera"
                                @click="goToDeviceManagement1(room.roomName)">监控</el-button>
                            <el-button type="primary" icon="el-icon-picture"
                                @click="goToDeviceManagement(room.roomName)">详情</el-button>
                        </div>
                    </el-card>
                </el-col>
            </div>
        </el-row>

        <!-- 分页控件 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[4, 8, 16, 32]" :page-size="pageSize" background
                layout="total, sizes, prev, pager, next, jumper" :total="totalCount" style="text-align: center;">
            </el-pagination>
        </div>

        <!-- 新增/编辑功能间弹窗（Vue2 调整 visible.sync + 移除 Vue3 特有属性） -->
        <el-dialog title="功能间信息" :visible.sync="dialogVisible" width="600px" :before-close="handleDialogClose"
            :z-index="2000" append-to-body>
            <el-form :model="form" :rules="formRules" ref="formRef" label-width="120px" class="mt-4">
                <el-form-item label="房间名称" prop="roomName">
                    <el-input v-model="form.roomName" placeholder="请输入功能间名称" />
                </el-form-item>
                <el-form-item label="房间面积(㎡)" prop="area">
                    <el-input v-model.number="form.area" placeholder="请输入房间面积" />
                </el-form-item>

                <el-form-item label="房间介绍" prop="description">
                    <el-input v-model="form.description" type="textarea" placeholder="请输入房间介绍" rows="2" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { delRoom, getRoomList, addRoom } from "@/api/function";
import { getDeviceList } from "@/api/device";
// Vue2 Element UI 引入 Message（不是 ElMessage）
import { Message, Loading, MessageBox } from 'element-ui';

export default {
    name: "FunctionRoom", // Vue2 推荐声明组件名
    data() {
        return {
            searchForm: { roomName: '' },
            roomList: [],        // 原始全部数据（接口返回的完整列表）
            filteredRoomList: [],// 筛选后的数据（用于分页展示）
            currentPage: 1,
            pageSize: 4,         // 默认每页4条
            totalCount: 0,
            dialogVisible: false,
            selectedRoomId: null,// 用于卡片选中状态
            form: {
                roomName: '',
                area: 0,
                description: ''
            },
            formRules: {
                roomName: [{ required: true, message: '请输入功能间名称', trigger: 'blur' }],
                area: [
                    { required: true, message: '请输入房间面积', trigger: 'blur' },
                    { type: 'number', min: 1, message: '房间面积不能小于1㎡', trigger: 'blur' }
                ],
                description: [{ required: true, message: '请输入房间介绍', trigger: 'blur' }]
            }
        }
    },
    computed: {
        // 计算总用电量
        totalElectricity() {
            return this.roomList.reduce((total, room) => total + Number(room.electricity), 0);
        },
        // 计算总用水量
        totalWater() {
            return this.roomList.reduce((total, room) => total + Number(room.waterUsage), 0);
        },
        // 计算平均单位面积用电量
        avgElectricityPerArea() {
            const totalArea = this.roomList.reduce((total, room) => total + Number(room.area), 0);
            return totalArea > 0 ? this.totalElectricity / totalArea : 0;
        },
        // 计算平均单位面积用水量
        avgWaterPerArea() {
            const totalArea = this.roomList.reduce((total, room) => total + Number(room.area), 0);
            return totalArea > 0 ? this.totalWater / totalArea : 0;
        },
        // 分页处理后的数据（基于筛选后的数据）
        paginatedRoomList() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredRoomList.slice(startIndex, endIndex);
        }
    },
    mounted() {
        this.getRoomList();
    },
    methods: {
        goToDeviceManagement(roomName) {
            this.$router.push({
                path: '/functionaldata',
                query: { roomName }
            });
        }, goToDeviceManagement1(roomName) {
            this.$router.push({
                path: '/monitor',
                query: { roomName }
            });
        },
        // 获取功能间列表（初始化原始数据）
        getRoomList() {
            getRoomList({ userId: localStorage.getItem('userId') }).then(response => {
                this.roomList = response.data || [];
                // 修复点1：重新执行筛选逻辑，保证数据同步
                this.handleSearch();
            }).catch(error => {
                console.error('获取功能间列表失败:', error);
                Message.error('获取功能间列表失败，请重试');
            });
        },

        // 核心：查询功能（模糊匹配功能间名称）
        handleSearch() {
            const keyword = this.searchForm.roomName.trim();
            // 无关键词时显示全部数据
            if (!keyword) {
                this.filteredRoomList = [...this.roomList];
            } else {
                // 模糊筛选：忽略大小写，匹配功能间名称
                this.filteredRoomList = this.roomList.filter(room => {
                    return room.roomName && room.roomName.toLowerCase().includes(keyword.toLowerCase());
                });
                // 无匹配数据时提示
                if (this.filteredRoomList.length === 0) {
                    Message.info(`未找到包含「${keyword}」的功能间`);
                }
            }
            // 修复点2：统一更新分页信息，确保数据实时同步
            this.totalCount = this.filteredRoomList.length;
            // 修复点3：如果当前页码超过总页数，自动重置到最后一页
            const maxPage = Math.ceil(this.totalCount / this.pageSize) || 1;
            if (this.currentPage > maxPage) {
                this.currentPage = maxPage;
            }
        },

        // 重置查询条件
        resetSearch() {
            this.searchForm = { roomName: '' };
            this.currentPage = 1;  // 重置页码
            this.handleSearch(); // 调用筛选逻辑刷新数据
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;  // 重置页码
            // 触发筛选逻辑，更新分页数据
            this.handleSearch();
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        showAddDialog() {
            this.dialogVisible = true;
            this.form = {
                roomName: '',
                area: 0,
                description: '',
                userId: localStorage.getItem('userId')
            };
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },

        showEditDialog(row) {
            this.dialogVisible = true;
            this.form = { ...row };
            this.$nextTick(() => {
                if (this.$refs.formRef) {
                    this.$refs.formRef.clearValidate();
                }
            });
        },

        handleDialogClose() {
            this.dialogVisible = false;
            if (this.$refs.formRef) {
                this.$refs.formRef.clearValidate();
            }
        },

        submitForm() {
            if (!this.$refs.formRef) return;
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    addRoom(this.form).then(response => {
                        console.log(response);
                        Message.success('新增成功');
                        this.dialogVisible = false;
                        this.getRoomList(); // 重新获取列表
                    }).catch(error => {
                        console.error('新增功能间失败:', error);
                        Message.error('新增失败，请重试');
                    });
                } else {
                    Message.warning('请完善表单必填项');
                }
            });
        },

        // 核心修改：删除前先检查设备关联 + 修复分页刷新问题
        async handleDelete(roomId) {
            try {
                // 1. 加载中提示，Vue2 使用 Loading.service
                const loadingInstance = Loading.service({ text: '正在检查设备关联...' });

                // 2. 调用getDeviceList接口，传入roomId查询该功能间下的设备
                const deviceRes = await getDeviceList({
                    roomId: roomId,
                    userId: localStorage.getItem('userId')
                });

                loadingInstance.close(); // 关闭加载提示

                // 3. 检查是否有设备
                const deviceList = deviceRes.data || [];
                if (deviceList.length > 0) {
                    Message.warning('该功能间下关联了设备，无法删除，请先移除相关设备！');
                    return;
                }

                // 4. 无设备时，弹出删除确认框（Vue2 使用 MessageBox.confirm）
                MessageBox.confirm(
                    '此操作将永久删除该功能间记录, 是否继续?',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(async () => {
                    // 5. 执行删除操作
                    try {
                        const response = await delRoom({
                            id: roomId,
                            userId: localStorage.getItem('userId')
                        });
                        if (response.code === 200) {
                            // 修复点4：先删除本地数据（兜底），再重新拉取最新数据
                            this.roomList = this.roomList.filter(item => item.id !== roomId);
                            // 修复点5：手动触发筛选和分页更新，保证实时性
                            this.handleSearch();
                            Message.success('删除成功');
                            // 重新拉取最新数据（确保和后端同步）
                            this.getRoomList();
                        } else {
                            Message.error(`删除失败：${response.message || "未知错误"}`);
                        }
                    } catch (error) {
                        console.error("删除功能间失败:", error);
                        Message.error("网络错误，删除失败");
                    }
                }).catch(() => {
                    Message.info('已取消删除');
                });

            } catch (error) {
                Loading.service().close(); // 兜底关闭加载
                console.error("检查设备关联失败:", error);
                Message.error("检查设备关联失败，请重试！");
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-container {
    flex: 1;
    margin-top: 20px;
    overflow-y: auto;
    padding: 0 20px 20px;
    max-height: calc(100vh - 35vh);
    height: calc(100vh - 35vh);
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.pagination-container {
    padding: 20px 0;
    margin-top: auto;
    background-color: #fff;
    z-index: 2;
    position: fixed;
    width: 100%;
    bottom: 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

/* 房间卡片样式 */
.room-card {
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }
}

.room-card .card-header {
    padding: 12px 15px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 32px;
    font-weight: bold;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
}

.room-card .card-body {
    padding: 15px;
    flex: 1;
    overflow-y: auto;
}

.room-card .info-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    color: #666;
}

.room-card .info-item .label {
    color: #999;
}

.room-card .card-footer {
    padding: 10px 15px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.demo-form-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
}

.el-dialog__body {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.el-form-item {
    margin-bottom: 20px;
}

/* 能耗卡片样式 */
.energy-card {
    margin-right: 10px;
    height: 120px;
    border-radius: 6px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #606266;
    font-size: 14px;
    padding: 12px 15px 8px;
}

.energy-value {
    font-size: 24px;
    font-weight: bold;
    color: #1890ff;
    text-align: center;
    padding-top: 10px;
}
</style>